export default __webpack_public_path__ + "static/thumb-audio3-d254df8364cb13559f85afb49a22f4ac.png";